export default __webpack_public_path__ + "static/media/error.720f3c94.mp3";